<script lang="ts">
  import type { NewsFromManyResponse } from '@entities/news/types';

  import Article from './article.svelte';

  export let news: NewsFromManyResponse['data'];
</script>

<ul class="pb-12 pt-8 md:p-0">
  {#each news as article}
    <Article {article} />
  {/each}
</ul>
